import { Vacaciones } from "../../components";
import "./stylesCategoriaVacaciones.scss";

export const CategoriaVacaciones = () => (
  <div>
    <Vacaciones />
  </div>
);
